'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var connect = require('react-redux').connect;
var PreviewMixin = require('./Mixin/Preview.jsx');
var storeHelper = require('../helper/storeHelper');

var Actions = require('../actions/AppActions');

var PreviewPanel = require('./PreviewPanel.jsx');
var Workspace = require('./Workspace.jsx');
var RenderTimePanel = require('./Dev/RenderTimePanel');
var TestProjects = require('./Dev/TestProjects');
var NavigationBar = require('./NavigationBar');
var PageRemark = require('./PageRemark');

var deviceShellHelper = require('../helper/deviceShellHelper');
var colorHelper = require('../helper/colorHelper');
var assetsHelper = require('../helper/assetsHelper');
var configHelper = require('../helper/configHelper');
var domHelper = require('../helper/domHelper');
var cacheHelper = require('../helper/cacheHelper');

var PCPreview = React.createClass({
  propTypes: {
    app: React.PropTypes.object,
    current: React.PropTypes.object,
    target: React.PropTypes.object,
    path: React.PropTypes.string.isRequired,
    animation: React.PropTypes.object,
    pages: React.PropTypes.object,
    onLoadApp: React.PropTypes.func.isRequired
  },
  mixins: [PreviewMixin],
  getInitialState: function () {
    var config = this.props.config;
    var platform = this.props.app.params.projectParam.platform;
    return _.extend(config, {
      scale: 1,
      canFix: platform === 'MtMobile' || platform === 'MtPad',
      shell: config.shell || deviceShellHelper.getShellInfoByPlatform(this.props.app.params.projectParam.platform),
      controlPanel: config.showControlPanel,
      domSize: domHelper.getDocumentSize(),
      showRemark: false,
      pageNeedRerender: true // 只有该值为 true 时页面内容才会得到更新，这不是一个好办法，但是目前来说，页面内的数据不能轻易被刷新，否则会引起交互错误，必须这样处理
    });
  },
  componentDidMount: function () {
    this.props.onLoadApp(this.props.app);
    domHelper.onDocumentResize(this.onDomSizeChange);
  },
  componentWillUnmount: function () {
    domHelper.offDocumentResize(this.onDomSizeChange);
  },
  componentDidUpdate: function () {
    if (this.state.pageNeedRerender) { // 如果该值为 true, 渲染完成后立即重置为 false
      this.setState({
        pageNeedRerender: false
      });
    }
  },
  componentWillReceiveProps: function (nextProps, nextState) {
    var currentID = this.props.current && this.props.current.ID;
    var nextID = nextProps && nextProps.target && nextProps.target.ID;
    this.setState({
      pageNeedRerender: currentID !== nextID
    }); // 当页面ID不同时才重新渲染
  },
  render: function () {
    var logoPath;
    var className = 'app';
    var pageRemark;
    if (!this.props.current) {
      logoPath = this.state.logo;
      return (
        <div className="preview-loading">
          <img width="120" height="120" src={logoPath} alt="Mockplus"/>
        </div>
      );
    }
    if (this.state.alwaysShowLinks) {
      className += ' always-show-links';
    } else if (this.state.hoverShowLinks) {
      className += ' hover-show-links';
    }
    if (this.state.hoverShowRemarks) {
      className += ' hover-show-remarks';
    }
    pageRemark = decodeURI(this.props.current.param[0].remark || '');
    return (
      <div className={className} style={{
        backgroundColor: this.state.background
      }}>
        <NavigationBar
          domSize={this.state.domSize}
          onOpenHome={this.onOpenHome}
          onOpenNext={this.onOpenNext}
          onOpenPrev={this.onOpenPrev}
          onPlayback={this.onPlayback}
          controlPanel={this.state.controlPanel}
          hasRemark={!!pageRemark}
          onTogglePanelVisibility={this.onTogglePanelVisibility}
          onToggleRemarkVisibility={this.onToggleRemarkVisibility}
        />
        {window.isDev && <TestProjects openApp={this.openApp}/> }
        {this.state.controlPanel &&
        <PreviewPanel
          domSize={this.state.domSize}
          app={this.props.app}
          current={this.props.current}
          scale={this.state.scale}
          shell={this.state.shell}
          showComments={this.state.showComments}
          alwaysShowLinks={this.state.alwaysShowLinks}
          hoverShowLinks={this.state.hoverShowLinks}
          hoverShowRemarks={this.state.hoverShowRemarks}
          showPanel={this.state.showControlPanel}
          showQRCode={this.state.showQRCode}
          onOpenPage={this.onOpenPage}
          onScaleChange={this.onScaleChange}
          onShowComments={this._onShowComments}
          onAlwaysShowLinks={this.onAlwaysShowLinks}
          onHoverShowLinks={this.onHoverShowLinks}
          onHoverShowRemarks={this.onHoverShowRemarks}
          onSetPanelVisibility={this.onSetPanelVisibility}
        />
        }
        {this.props.current &&
        <Workspace
          domSize={this.state.domSize}
          meta={this.props.meta}
          pages={this.props.pages}
          current={this.props.current}
          target={this.props.target}
          animation={this.props.animation}
          app={this.props.app}
          scale={this.state.scale}
          shell={this.state.shell}
          showComments={this.state.showComments}
          canFix={this.state.canFix}
          onShowRemark={this.onShowRemark}
          onRedirectTo={this.props.onRedirectTo}
          onOpenPage={this.onOpenPage}
          alwaysShowLinks={this.state.alwaysShowLinks}
          hintLinks={this.state.hintLinks}
          scrollRemarks={this.state.scrollRemarks}
          pageNeedRerender={this.state.pageNeedRerender}
        />
        }
        {window.debug && <RenderTimePanel/> }
        <div className="remark" ref="remark"></div>
        <PageRemark name={this.props.current.title}
                    remark={pageRemark}
                    show={this.state.showRemark}
                    onClose={this.onToggleRemarkVisibility}/>
      </div>
    );
  },
  openApp: function (p) {
    storeHelper.set('path', p);
    window.location.reload();
  },
  onDomSizeChange: function () {
    this.setState({
      domSize: domHelper.getDocumentSize()
    });
  },
  _onShowComments: function (show) {
    this.setState({
      showComments: show
    });
  },
  onScaleChange: function (scale) {
    this.setState({
      scale: scale
    });
  },
  onAlwaysShowLinks: function (show) {
    this.setState({
      alwaysShowLinks: show
    });
  },
  onHoverShowLinks: function (show) {
    this.setState({
      hoverShowLinks: show
    });
  },
  onHoverShowRemarks: function (show) {
    this.setState({
      hoverShowRemarks: show
    });
  },
  onShowRemark: function (x, y, remark) {
    if (this.state.hoverShowRemarks) {
      var dom = ReactDOM.findDOMNode(this.refs.remark);
      if (remark) {
        dom.style.left = x + 12 + 'px';
        dom.style.top = y + 12 + 'px';
        dom.style.display = 'block';
        dom.innerHTML = remark.replace(/\n/g, '<br/>');
      } else {
        dom.style.display = 'none';
      }
    }
  },
  onSetPanelVisibility: function (visible) {
    this.setState({
      showControlPanel: visible
    });
  },
  onTogglePanelVisibility: function () {
    this.setState({
      showControlPanel: !this.state.showControlPanel
    });
  },
  onToggleRemarkVisibility: function () {
    this.setState({
      showRemark: !this.state.showRemark
    });
  }
});

function mapStateToProps(state) {
  cacheHelper.cache(cacheHelper.keys.PROJECT_VERSION, state.app && state.app.params.projectParam.version);
  cacheHelper.cache(cacheHelper.keys.PAGE_VERSION, state.current && state.current.version);
  cacheHelper.cache(cacheHelper.keys.PLATFORM, state.app && state.app.params.projectParam.platform);
  return {
    app: state.app,
    meta: state.app && state.app.params.projectParam,
    current: state.current,
    target: state.target,
    animation: state.animation,
    config: state.config,
    projectVersion: state.app && state.app.params.projectParam.version,
    pageVersion: state.current && state.current.version
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoadApp: function (app) {
      dispatch(Actions.loadApp(app));
    },
    onOpenPage: function (id) {
      dispatch(Actions.openPage(id));
    },
    onRedirectTo: function (id, animation) {
      dispatch(Actions.redirectPage(id, animation));
    }
  };
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(PCPreview);



// WEBPACK FOOTER //
// ./src/views/PCPreview.jsx